import {installDateTimePicker} from "../editors/DateTimeInput.js";

function fillTable(table, tableId)
{
	$('#'+tableId).html(table);
}

// **************
// COMMON SCRIPTS
// **************
export function printMessage(title, target)
{
	jQuery.ajax("ajax/Util.getMessage.jsp?title="+title).done(function(text) {
		$('#'+target).html(text);
	});
}
	
	
export function getFileName(file) 
{
	return file.name || file.fileName;
}

// *********************************
// PRODUCT PICKER
// *********************************
function loadProducts(producerPk)
{
	$('#product').empty();
	$.ajax("ajax/Product.getProductsOfProducer.jsp?producerPk="+producerPk).done(function(data) {
		let dobj = JSON.parse(data);
		for (var i = 0; i < dobj.length; i++) {
			var opt = '<option value="'+dobj[i].id+'">'+dobj[i].name+'</option>';
			$('#product').append(opt);
		}
	});
}

// ******************************************
// OUTPUT - ALLOW FORMAT SELECTION (only XML)
// ******************************************
export function showHideFormatSelection(template) {
	$("option.output-format").hide();

	$.get("ajaxOutput.do?template="+template).done(data => {
		let formats = data.formats;	// array of integers (supported formats)
		for (let f of formats) {
			$("option.output-format[value="+f+"]").show();
		}
		// check if selected option is also visible
		let formatOption = $('#formatRow');

		const selected = parseInt(formatOption.val());
		if (!formats.includes(selected)) {
			formatOption.val(formats[0].toString());
		}

		formatOption.prop('disabled', formats.length <= 1);
		$('#maxrows').text(data.maxRows);
	});

	$.get("templateForm.do?template="+template).done(data => {
		const df = $('#dynamicForm');
		df.html(data);
		df.find("code").each(function() {
			installDateTimePicker($(this).attr('id'));
		});
	});
}